export default [
    "20 20",
  '  <path d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"\n' +
  '        stroke="var(--ci-primary-color, currentColor)"\n' +
      '        fill="white"\n' +
  '        stroke-width="1.5"\n' +
  '        stroke-linecap="round"\n' +
  '        stroke-linejoin="round"/>\n' +
  '\n' +
  '  <path d="M10.0001 15.8333C13.2217 15.8333 15.8334 13.2217 15.8334 10C15.8334 6.77834 13.2217 4.16667 10.0001 4.16667C6.77842 4.16667 4.16675 6.77834 4.16675 10C4.16675 13.2217 6.77842 15.8333 10.0001 15.8333Z"\n' +
  '        fill="var(--ci-primary-color, currentColor)"/>\n' +
  '\n' +
  '  <path d="M7.5 10.0347L9.20139 11.7361L12.6042 8.33333"\n' +
  '        stroke="white"\n' +
  '        stroke-width="1.36111"\n' +
  '        stroke-linecap="round"\n' +
  '        stroke-linejoin="round"/>'
]